export const topics = [
  {
    id: "t1",
    title: "夏日电竞狂欢节",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20summer%20esports%20festival%20banner%2C%20glowing%20stage%20and%20game%20controllers%2C%20deep%20blue%20purple%20gradient%20with%20neon%20light%20beams%2C%20cinematic%20high%20detail%2C%20no%20text&width=1200&height=600&seq=topic-t1&orientation=landscape",
    summary:
      "整个夏天最热的电竞对决集中呈现，平台签约战队主播轮番开播，从排位冲榜到赛事解说，带你一次看个够。",
    liveIds: ["g1", "g2", "sp1", "sp3"],
    reasons: [
      "平台顶尖主播同台竞技，含金量拉满",
      "每日 19:00 连播不断档，追赛零压力",
      "弹幕竞猜赢虚拟礼物，边看边玩",
    ],
    comments: [
      { user: "电竞小迷弟", text: "冲榜那几场看得太爽了，节奏拉满！" },
      { user: "键盘侠本侠", text: "解说分析很到位，学到了几个运营思路。" },
      { user: "熬夜也要看", text: "连播不中断这个安排太贴心了。" },
    ],
  },
  {
    id: "t2",
    title: "深夜陪伴电台",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20late%20night%20radio%20banner%2C%20glowing%20microphone%20and%20city%20night%20lights%2C%20deep%20indigo%20teal%20gradient%2C%20moody%20cinematic%20detail%2C%20no%20text&width=1200&height=600&seq=topic-t2&orientation=landscape",
    summary:
      "为夜晚准备的一组温柔直播，脱口秀、翻唱与钢琴即兴轮番上线，让加班的你不再孤单。",
    liveIds: ["e1", "mu1", "mu3", "lf1"],
    reasons: [
      "温柔陪伴向内容，适合睡前与加班",
      "主播互动积极，点歌留言有回应",
      "主题横跨脱口秀、音乐与美食",
    ],
    comments: [
      { user: "夜猫子阿花", text: "钢琴那场太治愈了，直接当背景音。" },
      { user: "加班中的打工人", text: "有直播陪着加班，好像没那么累了。" },
      { user: "音乐爱好者", text: "古风翻唱点歌体验无敌好。" },
    ],
  },
  {
    id: "t3",
    title: "开学季充电计划",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20back%20to%20school%20study%20banner%2C%20open%20books%20laptop%20and%20graduation%20cap%2C%20soft%20blue%20green%20gradient%2C%20clean%20modern%20lighting%2C%20no%20text&width=1200&height=600&seq=topic-t3&orientation=landscape",
    summary:
      "开学季精选学习直播，英语、编程、考研与职场技能一站集齐，名师陪你高效充电。",
    liveIds: ["ed1", "ed2", "ed3", "ed4"],
    reasons: [
      "一线名师直播授课，内容体系完整",
      "配套资料与回放，随时补课不落队",
      "覆盖语言、编程、考研与职场多方向",
    ],
    comments: [
      { user: "考研冲鸭", text: "张老师的高数串讲救了我的命。" },
      { user: "转行程序员", text: "爬虫实战课跟完就能自己动手了。" },
      { user: "职场新人", text: "汇报技巧真的用得上，已安利同事。" },
    ],
  },
  {
    id: "t4",
    title: "生活美学周",
    cover:
      "https://readdy.ai/api/search-image?query=vibrant%20modern%20lifestyle%20aesthetic%20banner%2C%20plants%20coffee%20and%20handmade%20crafts%2C%20warm%20terracotta%20green%20gradient%2C%20cozy%20natural%20lighting%2C%20no%20text&width=1200&height=600&seq=topic-t4&orientation=landscape",
    summary:
      "把日子过成喜欢的样子：美食、手工、阳台种植与古风妆造，慢下来感受生活的细节。",
    liveIds: ["lf1", "lf2", "lf3", "e3"],
    reasons: [
      "慢生活主题，节奏舒缓解压",
      "实用教程可边看边做，成就感满满",
      "主播亲和力强，社区氛围友好",
    ],
    comments: [
      { user: "厨房小白", text: "一锅炖真的零失败，今晚就试。" },
      { user: "手工爱好者", text: "皮具教程讲得很细，工具清单太实用。" },
      { user: "阳台种菜党", text: "跟着种了小番茄，已经发芽啦！" },
    ],
  },
];